const COPY = {
  en: {
    gameName: "SNOW RUSH",
    gameDialog: "Snow Rush ski game",
    soundOn: "SOUND ON",
    soundOff: "SOUND OFF",
    turnSoundOn: "Turn sound on",
    muteSound: "Mute sound",
    exit: "EXIT",
    closeGame: "Close game",
    readyImageAlt: "Sotravel skier ready at the mountain",
    ready: "READY TO RIDE?",
    prizePrompt: "Complete the run to win your prize.",
    checkingPrize: "GETTING READY...",
    loginToWin: "LOGIN TO WIN",
    startRun: "START RUN",
    wipeout: "WIPEOUT!",
    mountainWins: "The mountain wins this round.",
    tryAgain: "TRY AGAIN",
    celebrationAlt: "Sotravel skier celebrating on the mountain",
    courseCleared: "★ COURSE CLEARED ★",
    runComplete: "RUN COMPLETE!",
    prizeReady: "You conquered the mountain. Your prize is ready.",
    unavailable: "The ski prize draw is not available right now. Please try again later.",
    claimFailed: "We couldn't claim your prize. Please try again.",
    claiming: "CLAIMING...",
    claimPrize: "CLAIM PRIZE",
    tripDraw: "ALL SKI TRIPS",
    findingTrip: "YOUR PRIZE IS LANDING...",
    landingPrize: "Finding your mountain adventure",
    gameControls: "Game controls",
    moveLeft: "Move left",
    moveRight: "Move right",
    loadingPrize: "LOADING YOUR PRIZE...",
    noActivePrize: "NO ACTIVE PRIZE",
    noPrizeYet: "You don't have an active ski prize yet.",
    loadPrizeFailed: "We couldn't load your ski prize.",
    returnHome: "RETURN HOME",
    off: "OFF",
    exclusivelyFor: "EXCLUSIVELY FOR",
    yourCode: "YOUR CODE",
    copied: "COPIED!",
    copy: "COPY",
    expiresIn: "EXPIRES IN",
    hours: "HRS",
    minutes: "MINS",
    seconds: "SECS",
    codeExpired: "CODE EXPIRED",
    viewSkiTrip: "VIEW SKI TRIP",
    comeBackTomorrow: "COME BACK TOMORROW",
    anotherRun: "FOR ANOTHER SKI RUN!",
    dailyDrop: "👊 DAILY DROP",
    rareDrop: "🔥 RARE DROP",
    ultraRareDrop: "💎 ULTRA RARE DROP",
    ultraRareDescription: "You hit the biggest reward!",
  },
  zhHans: {
    gameName: "雪地冲刺",
    gameDialog: "雪地冲刺滑雪游戏",
    soundOn: "开启声音",
    soundOff: "关闭声音",
    turnSoundOn: "开启声音",
    muteSound: "关闭声音",
    exit: "退出",
    closeGame: "关闭游戏",
    readyImageAlt: "Sotravel 滑雪者在雪山准备出发",
    ready: "准备好滑雪了吗？",
    prizePrompt: "完成赛道即可赢取奖品。",
    checkingPrize: "正在准备…",
    loginToWin: "登录赢奖品",
    startRun: "开始滑雪",
    wipeout: "摔倒了！",
    mountainWins: "这一回合雪山赢了。",
    tryAgain: "再试一次",
    celebrationAlt: "Sotravel 滑雪者在雪山庆祝",
    courseCleared: "★ 完成赛道 ★",
    runComplete: "滑雪完成！",
    prizeReady: "你征服了雪地冲刺，雪山奖品已准备好。",
    unavailable: "滑雪抽奖目前无法使用，请稍后再试。",
    claimFailed: "无法领取奖品，请再试一次。",
    claiming: "领取中…",
    claimPrize: "领取奖品",
    tripDraw: "所有滑雪行程",
    findingTrip: "你的奖品即将揭晓…",
    landingPrize: "正在寻找你的雪山旅程",
    gameControls: "游戏控制",
    moveLeft: "向左移动",
    moveRight: "向右移动",
    loadingPrize: "正在加载奖品…",
    noActivePrize: "没有有效奖品",
    noPrizeYet: "你目前没有有效的滑雪奖品。",
    loadPrizeFailed: "无法加载你的滑雪奖品。",
    returnHome: "返回首页",
    off: "优惠",
    exclusivelyFor: "仅适用于",
    yourCode: "你的优惠码",
    copied: "已复制！",
    copy: "复制",
    expiresIn: "有效期剩余",
    hours: "小时",
    minutes: "分钟",
    seconds: "秒",
    codeExpired: "优惠码已过期",
    viewSkiTrip: "查看滑雪行程",
    comeBackTomorrow: "明天再来",
    anotherRun: "参加另一场滑雪挑战！",
    dailyDrop: "👊 每日奖励",
    rareDrop: "🔥 稀有奖励",
    ultraRareDrop: "💎 超稀有奖励",
    ultraRareDescription: "你抽中了最高奖励！",
  },
  zhHant: {
    gameName: "雪地衝刺",
    gameDialog: "雪地衝刺滑雪遊戲",
    soundOn: "開啟聲音",
    soundOff: "關閉聲音",
    turnSoundOn: "開啟聲音",
    muteSound: "關閉聲音",
    exit: "離開",
    closeGame: "關閉遊戲",
    readyImageAlt: "Sotravel 滑雪者在雪山準備出發",
    ready: "準備好滑雪了嗎？",
    prizePrompt: "完成賽道即可贏取獎品。",
    checkingPrize: "正在準備…",
    loginToWin: "登入贏獎品",
    startRun: "開始滑雪",
    wipeout: "摔倒了！",
    mountainWins: "這一回合雪山贏了。",
    tryAgain: "再試一次",
    celebrationAlt: "Sotravel 滑雪者在雪山慶祝",
    courseCleared: "★ 完成賽道 ★",
    runComplete: "滑雪完成！",
    prizeReady: "你征服了雪地衝刺，雪山獎品已準備好。",
    unavailable: "滑雪抽獎目前無法使用，請稍後再試。",
    claimFailed: "無法領取獎品，請再試一次。",
    claiming: "領取中…",
    claimPrize: "領取獎品",
    tripDraw: "所有滑雪行程",
    findingTrip: "你的獎品即將揭曉…",
    landingPrize: "正在尋找你的雪山旅程",
    gameControls: "遊戲控制",
    moveLeft: "向左移動",
    moveRight: "向右移動",
    loadingPrize: "正在載入獎品…",
    noActivePrize: "沒有有效獎品",
    noPrizeYet: "你目前沒有有效的滑雪獎品。",
    loadPrizeFailed: "無法載入你的滑雪獎品。",
    returnHome: "返回首頁",
    off: "優惠",
    exclusivelyFor: "僅適用於",
    yourCode: "你的優惠碼",
    copied: "已複製！",
    copy: "複製",
    expiresIn: "有效期剩餘",
    hours: "小時",
    minutes: "分鐘",
    seconds: "秒",
    codeExpired: "優惠碼已過期",
    viewSkiTrip: "查看滑雪行程",
    comeBackTomorrow: "明天再來",
    anotherRun: "參加另一場滑雪挑戰！",
    dailyDrop: "👊 每日獎勵",
    rareDrop: "🔥 稀有獎勵",
    ultraRareDrop: "💎 超稀有獎勵",
    ultraRareDescription: "你抽中了最高獎勵！",
  },
};

export const getSkiCopy = (language) => {
  if (language === "zh-Hans-CN" || String(language).toLowerCase().startsWith("zh-hans")) {
    return COPY.zhHans;
  }
  if (language === "zh-Hant-TW" || String(language).toLowerCase().startsWith("zh-hant")) {
    return COPY.zhHant;
  }
  return COPY.en;
};
